const doc = [({"languages":[({"locale":"de", "name":"Deutsch"}), ({"locale":"en", "name":"English"})]})];
module.exports = doc.length <= 1 ? doc[0] : doc;